import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'insight-mini-card',
  template: `
    <div class="insight-mini-card" fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
      <div fxFlex class="mini-card-text" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <span>{{ text | uppercase }}</span>
      </div>
      <div [style.color]="percentageColor" class="percentage" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <span>{{ percentage }}</span>
      </div>
    </div>
  `,
  styles: [
    `
      .insight-mini-card {
        border-top: 1px solid #f1eded;
        border-right: 1px solid #f1eded;
        height: 50px;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
      }
      .mini-card-text {
        font-size: 11px;
        font-weight: 800;
        padding-right: 15px;
      }
      .percentage {
        font-size: 24px;
      }
    `,
  ],
})
export class InsightMiniCardComponent implements OnInit {
  @Input() text: string;
  @Input() percentage?: string;
  @Input() percentageColor?: string;

  ngOnInit() {
    if (this.percentage && !this.percentage.includes('%')) {
      this.percentage = this.percentage + '%';
    }
  }
}
